import { Edit, useNotify } from 'react-admin';
import { useTitle } from '@src/hooks/useTitle';
import { VariantSkuForm } from './VariantSkuForm';
import { VariantSkuEditToolbar } from './VariantSkuEditToolbar';
import { VariantSkuEditActions } from './VariantSkuEditActions';

/**
 * Edit view for individual variant SKUs
 * Allows editing product identifiers (UPC, MPN, GTIN, Partner SKU, Partner Parent SKU)
 * and custom JSON fields (Family and Data)
 */
export const VariantSkuEdit = () => {
  const { title } = useTitle('Edit Variant SKU');
  const notify = useNotify();

  return (
    <Edit
      mutationMode="pessimistic"
      actions={<VariantSkuEditActions />}
      title={title}
      mutationOptions={{
        onSuccess: () => {
          notify('Variant SKU updated', { type: 'success' });
        },
      }}
      sx={{
        '& .RaEdit-main': {
          marginTop: 0,
        },
        '& .RaEdit-card': {
          marginTop: 0,
        }
      }}
    >
      <VariantSkuForm toolbar={<VariantSkuEditToolbar />} />
    </Edit>
  );
};
